import React, { useState } from 'react';
import MenuHolder from '../menu';

const HomeView = () => (
    <div>
        <MenuHolder />
    </div>
)

export default HomeView;